import React from "react";

const PageNotFound = () => {
  return <div style={{color:'green',width:'500px',height:'500px',fontSize:'50px',position:'relative', left:'450px',top:"100px"}}>404 PageNotFound</div>;
};

export default PageNotFound;